$('.block--check-list__item__toggle').on('click keyup', function (event) {
    if (event.type === 'click' || (event.type === 'keyup' && (event.keyCode === 13 || event.which === 13))) {
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
        $(this).toggleClass('active'); 
        const listId = $(this).attr('id'); 
        const listRows = $('.block--check-list__item__rows[data-list="' + listId + '"]');
        listRows.attr('aria-hidden', listRows.attr('aria-hidden') === 'true' ? 'false' : 'true');

        listRows.slideToggle();
    }
});

$('.block--facts__items__toggle').on('click keyup', function (event) {
    if (event.type === 'click' || (event.type === 'keyup' && (event.keyCode === 13 || event.which === 13))) {
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
        $(this).toggleClass('active'); 
        const listId = $(this).attr('id'); 
        const listRows = $('.block--facts__items--hide[data-list="' + listId + '"]');
        listRows.attr('aria-hidden', listRows.attr('aria-hidden') === 'true' ? 'false' : 'true');

        listRows.slideToggle();
    }
});
